module.exports = __webpack_public_path__ + "static/media/CCBSignupPage.0e4178d7.png";